import { render, staticRenderFns } from "./shoping.vue?vue&type=template&id=91c4690c&scoped=true"
import script from "./shoping.vue?vue&type=script&lang=js"
export * from "./shoping.vue?vue&type=script&lang=js"
import style0 from "./shoping.vue?vue&type=style&index=0&id=91c4690c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c4690c",
  null
  
)

export default component.exports